import "../../sass/pages/panam/tenis_panam_store.scss";

console.log('asdadasdsada');

const test = () => {
  console.log("Ferias ts");
};

const displayAllContent = () => {
  
}

(function page() {
  test();
})();
